const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediafysdk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.88 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.96,28.39v11.4h-5.48v-10.51c0-3.22-1.37-4.7-3.59-4.7-2.46,0-4.18,1.67-4.18,5.22v10h-5.48v-10.51c0-3.22-1.3-4.7-3.59-4.7-2.43,0-4.15,1.67-4.15,5.22v10H0v-19.92h5.24v2.3c1.41-1.7,3.52-2.59,5.94-2.59,2.64,0,4.89,1.07,6.22,3.26,1.51-2.04,3.97-3.26,6.82-3.26,4.5,0,7.73,2.74,7.73,8.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.26,31.46h-14.31c.53,2.48,2.53,4,5.41,4,2,0,3.45-.63,4.75-1.92l2.92,3.33c-1.76,2.11-4.39,3.22-7.8,3.22-6.54,0-10.79-4.33-10.79-10.25s4.32-10.25,10.09-10.25,9.84,3.92,9.84,10.33c0,.44-.07,1.07-.11,1.55ZM39.88,28.1h9.32c-.39-2.52-2.18-4.15-4.64-4.15s-4.29,1.59-4.68,4.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.44,12.33v27.47h-5.24v-2.29c-1.37,1.74-3.38,2.59-5.91,2.59-5.34,0-9.46-4-9.46-10.25s4.11-10.25,9.46-10.25c2.32,0,4.29.78,5.66,2.41v-9.66h5.48ZM72.06,29.84c0-3.44-2.11-5.52-4.82-5.52s-4.85,2.07-4.85,5.52,2.11,5.52,4.85,5.52,4.82-2.07,4.82-5.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.89,28.43v11.36h-5.13v-2.48c-1.02,1.81-2.99,2.78-5.77,2.78-4.43,0-7.07-2.59-7.07-6.03s2.36-5.96,8.12-5.96h4.36c0-2.48-1.41-3.92-4.36-3.92-2,0-4.08.7-5.45,1.85l-1.97-4.04c2.07-1.55,5.13-2.41,8.16-2.41,5.77,0,9.11,2.81,9.11,8.85ZM101.41,33.5v-2.04h-3.76c-2.57,0-3.38,1-3.38,2.33,0,1.44,1.16,2.41,3.09,2.41,1.83,0,3.41-.89,4.04-2.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.63,19.88h4.85v4.43h-4.71v15.49h-5.48v-15.49h-2.92v-4.43h2.92v-.44c0-4.48,2.6-7.4,7.31-7.4,1.55,0,3.16.33,4.18,1.07l-1.44,4.18c-.6-.44-1.37-.7-2.21-.7-1.62,0-2.5.92-2.5,2.89v.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.54,19.88l-8.54,21.14c-1.83,4.81-4.43,6.26-7.84,6.26-1.93,0-4.04-.67-5.27-1.81l2-4.11c.84.78,2,1.26,3.09,1.26,1.51,0,2.36-.7,3.09-2.48l.07-.18-8.19-20.06h5.66l5.31,13.51,5.34-13.51h5.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.5,19.88h5.48v19.92h-5.48v-19.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.18,
    cy: 15.3,
    r: 3.27,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M193.73,27.11c-.19-.07-.39-.13-.59-.2-1.34-.44-2.29-.82-2.29-1.74,0-1,1.09-1.37,1.83-1.37,1.21,0,2.51.59,3.97,1.8l.29.24,3.12-3.91-.31-.23c-2.35-1.78-4.55-2.57-7.13-2.57-3.48,0-7.22,1.9-7.22,6.06s2.84,5.46,5.76,6.56l.16.06c1.7.62,3.3,1.2,3.3,2.49,0,1.37-1.33,1.86-2.47,1.86-2,0-3.09-1.02-4.68-2.48l-.26-.24-3.57,3.5.26.27c2.46,2.49,5.06,3.65,8.19,3.65,3.98,0,8.26-2.08,8.26-6.64,0-4.83-3.99-6.21-6.63-7.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.58,19.46h-6.47v21.05h6.21c5.73,0,11.86-2.79,11.86-10.61s-6.25-10.44-11.6-10.44ZM208.56,24.09h.55c4.08,0,6.33,2.15,6.33,6.06s-2.31,5.69-6.88,5.72v-11.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.82 19.26 235.9 19.26 229.44 27.56 229.44 19.26 223.73 19.26 223.73 40.51 229.44 40.51 229.44 32.06 235.84 40.51 242.8 40.51 234.25 29.67 242.82 19.26",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 157.39,
    y: -4.41,
    width: 17.43,
    height: 47.53,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(62.34 -111.78) rotate(45)",
    style: {
      fill: "#4fc642"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.39,
    y: 16.88,
    width: 17.43,
    height: 47.53,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(312.3 -48.07) rotate(135)",
    style: {
      fill: "#009aff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 255.8,
    y: 16.88,
    width: 17.43,
    height: 47.53,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(422.82 256.43) rotate(-135)",
    style: {
      fill: "#fbd800"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.8,
    y: -4.41,
    width: 17.43,
    height: 47.53,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(63.79 192.71) rotate(-45)",
    style: {
      fill: "#c322ff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediafysdk);
export default __webpack_public_path__ + "static/media/mediafysdk.98e1a55edd671f10af27ee07dfadf546.svg";
export { ForwardRef as ReactComponent };